import { render, staticRenderFns } from "./VolunteersManagement.vue?vue&type=template&id=21c2eb44&scoped=true&"
import script from "./VolunteersManagement.vue?vue&type=script&lang=js&"
export * from "./VolunteersManagement.vue?vue&type=script&lang=js&"
import style0 from "./VolunteersManagement.vue?vue&type=style&index=0&id=21c2eb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2eb44",
  null
  
)

export default component.exports